import React, { Component } from "react";
import { View, ScrollView, Text, TextInput } from 'react-native'
import { connect } from "react-redux";
import actions from "../../../actions";
import {Header,Label,Form} from "../../../components/SharedComponents";
import styles from "../../../shared/styles";
import { global, action } from "../../../utils";
import InviteMessage from "./components/InviteMessage";
import InvitationSuccess from "./components/InvitationSuccess";
import InviteFamilyMember from "./components/InviteFamilyMember";
import localize from "../../../shared/localize";


class InviteUsers extends Component {

    valid_email = [];

    constructor(props) {
        super(props);
        let role_type = 0;
        if (global.isNative) {
            role_type = props.navigation.getParam("role") || 0
        } else {
            if (props.history.location.state)
                role_type = props.history.location.state.role;
        }

        this.state = {
            invite: "",
            inviteError: undefined,
            im_status: false,
            inviteComplate: false,
            role_type,
            familyName: props.userInfo.family_name
        }
    }

    onInviteStatus = () => {
        const { im_status, invite } = this.state;

        if (im_status && this.valid_email.length > 0)
            return this.sendInvite();

        let email_array = invite.split(/[,\;/]/);
        email_array.map((item, index) => email_array[index] = item.trim())
        let valid_email = [];
        email_array.map(item => {
            if (!item.match(global.EMAIL_VALIDATION)) return;
            valid_email.push(item)
        })
        if (valid_email.length > 0) {
            this.valid_email = valid_email
            return this.setState({ im_status: true, inviteError: "" })
        }
        return this.setState({ inviteError: localize.Enter_valid_email_address });
    }

    _sliceEmails = () => {
        let emailString = '';
        this.valid_email.map(item => emailString += ',' + item)
        emailString = emailString.slice(1)
        return emailString
    }

    sendInvite = async () => {
        this.props.isLoading(true);

        try {
            let response = await this.props.sendMessage(this._sliceEmails(), this.state.role_type);
            if (response === 200) this.setState({ inviteComplate: true, im_status: false, inviteError: '' });
        } catch (error) {
            console.log(error)
            this.setState({ im_status: false, inviteError: localize.Something_is_wrong });
        }
        this.props.isLoading(false);
    }



    handleGoBack = () => {
        const { im_status } = this.state;
        if (im_status) {
            return this.setState({ im_status: !im_status })
        }
        if (global.isNative)
            return this.props.navigation.goBack()
        this.props.history.goBack();
    }

    render() {
        const { inviteComplate, invite, familyName, im_status, inviteError, role_type } = this.state;
        let title = localize.formatString(localize.Invite_trusted_child_to_your, familyName),
            headerTitle = localize.Invite_Child;
        if (role_type === 1) {
            title = localize.formatString(localize.Invite_trusted_adults_like_parents, familyName);
            headerTitle = localize.Invite_Adult;
        }
        if (role_type === 2) {
            title = localize.formatString(localize.Invite_trusted_Teacher_like, familyName);
            headerTitle = localize.Invite_Teacher;
        }

        return (
            <View style={{ flex: 1 }}>
                {
                    inviteComplate ? <Header title={headerTitle} /> : <Header title={headerTitle} goBack={this.handleGoBack} />
                }
                <ScrollView keyboardShouldPersistTaps="handled" style={{ height: this.props.height - 70 }}>
                    {
                        inviteComplate ?
                            <InvitationSuccess
                                invite={invite}
                                familyName={familyName}
                            />
                            :
                            (
                                <View style={{ marginHorizontal: 30, marginVertical: 20 }}>
                                    <Label.PrimaryTitle>
                                        {title}
                                    </Label.PrimaryTitle>
                                    <View style={styles.divider} />
                                    {
                                        !im_status ? (
                                            <InviteFamilyMember
                                                invite={invite}
                                                familyName={familyName}
                                                inviteError={inviteError}
                                                role_type={role_type}
                                                onChangeText={(text) => this.setState({ invite: text })}
                                            />)
                                            : (
                                                <InviteMessage
                                                    emails={this.valid_email}
                                                    role_type={role_type}
                                                />
                                            )
                                    }
                                    <Form.Button
                                        title={im_status ? localize.Send_Message : localize.Next}
                                        onPress={this.onInviteStatus}
                                    />
                                </View>
                            )
                    }
                </ScrollView>
            </View>
        );
    }
}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        sendMessage: (mail_address, role_type) => dispatch(actions.sendMessage(mail_address, role_type)),
        isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(InviteUsers);